<div class="re-px-20 re-pb-20 md:re-px-30 md:re-pb-30">
  <div class="re-block re-mb-15 md:re-mb-20 re-mt-30 re-small-bold">
    {{ 'tariff.details.title' | translate }}
  </div>
  <div class="re-xs">{{tariffData?.durations[0]?.termString}}</div>
</div>
